import { useState, useEffect, useRef, useDebugValue } from "react";
import { useUser } from "../../hooks/useUser";
import apiClient from "../../api/axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useQuery } from "@tanstack/react-query";
import useFileUploader from "../../hooks/useFileUploader";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import useProducts from "../../hooks/useProducts";
import Editor from "../../layouts/Editor";
import usePath from "../../hooks/usePath";

// ✅ ADD ONLY (do not remove anything)
import useMapLocation from "../../hooks/useMapLocation";
import { useMyVendor, useVendorById } from "../../hooks/useVendor";
import useAdminSettings from "../../hooks/useAdminSettings";

// Convert to time to secounds
function toTimeWithSeconds(time) {
  if (!time) return null;
  // If already has seconds, return as is
  if (/^\d{2}:\d{2}:\d{2}$/.test(time)) return time;
  // If only HH:mm, add :00 and pad
  if (/^\d{1,2}:\d{2}$/.test(time)) {
    let [h, m] = time.split(":");
    h = h.padStart(2, "0");
    return `${h}:${m}:00`;
  }
  return null;
}

// Product add or update
export default function AddorUpdate() {
  //Get current login user data
  const { data: user } = useUser();

  //Help to navigate page
  const navigate = useNavigate();

  // Admin Settings
  const { getSettingValue } = useAdminSettings();
  const rawMinCommission = getSettingValue("delivery.minimum_commission", 0);
  const minCommission = parseFloat(rawMinCommission) || 0;

  useEffect(() => {
    console.log("Min Commission Loaded:", minCommission);
  }, [minCommission]);

  //Upload image
  const { uploadImage } = useFileUploader();

  const [productImage, setProductImage] = useState(null);
  const [productImagePreview, setProductImagePreview] = useState("");
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);

  // disply for error
  const [error, setError] = useState("");

  //Form data for submit the data
  const [formData, setFormData] = useState({
    vendorName: "",
    product_id: 0,
    productName: "",
    productType: "",
    category: "",
    subcategory: "",
    brand: "",
    unit: "",
    tags: [],
    description: "",
    exchangeable: false,
    refundable: true,
    ageValidation: false,
    status: "active",
    images: [],
    old_url: "",
    product_image: "",
    thumbnailImage: null,
    videoProvider: "",
    videoLink: "",
    optionName: "",
    optionValue: [],
    weight: "",
    dimensions: "",
    price: "",
    comparePrice: "",
    costPerItem: "",
    sku: "",
    stockStatus: "In Stock",
    upsells: "",
    crossSells: "",
    pageTitle: "",
    metaDescription: "",
    urlHandle: "",
    taxValue: "",
    variants: [],
    availableFrom: "",
    availableTo: "",
    commissionPercent: "",
  });

  // Set default commission when loaded/changed
  useEffect(() => {
    if (
      minCommission &&
      (formData.commissionPercent === "" || formData.commissionPercent === 0)
    ) {
      setFormData((prev) => ({
        ...prev,
        commissionPercent: minCommission,
      }));
    }
  }, [minCommission]);

  // Add to state for vendor variable prices
  const [variablePrices, setVariablePrices] = useState([]);

  //get parmter variable for id
  const { id } = useParams();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const source = params.get("source"); // "vendor" or "list"
  const vendorId = params.get("vendor_id"); // For adding products to specific vendor

  //Check param
  // Check vendor or is vendor id found and admin or employee
  const isVendorOrSuperUsers = () => {
    return (
      user?.role === "vendor" ||
      (vendorId && (user?.role === "admin" || user?.role === "employee")) ||
      false
    );
  };

  // Get prodcts by id method will incude
  const { getProductsByid } = useProducts();

  // Fetch vendor product details by ID using the custom hook `useProducts`.
  // Destructure the result to get the data, loading state, and refetch function.
  const {
    data: vendorProductResult,
    isLoading: vendorProductLoading,
    refetch: refetchVendorProductResult,
  } = useProducts().getVendorProductDetailById(id);

  //  It has Variants available for product
  const [HasVariants, sethasVariants] = useState(false);

  //It has not vatants avilable it only single product
  const [singleProduct, setsingleProduct] = useState({});

  // Add state for new variant inputs (per variant by sku_id)
  const [newVariantInputs, setNewVariantInputs] = useState({});

  // Add state for common availability times
  const [commonAvailableFrom, setCommonAvailableFrom] = useState("");
  const [commonAvailableTo, setCommonAvailableTo] = useState("");

  // Add loading state for vendor edit save
  const [vendorSaveLoading, setVendorSaveLoading] = useState(false);
  const [alwaysAvailable, setAlwaysAvailable] = useState(true);

  // State
  // State for toggle
  const [availableAllDays, setAvailableAllDays] = useState(true);

  const [daysOfWeek, setdateOfWeek] = useState([
    {
      title: "Monday",
      Isenable: false,
    },

    {
      title: "Tuesday",
      Isenable: false,
    },
    {
      title: "Wednesday",
      Isenable: false,
    },
    {
      title: "Thursday",
      Isenable: false,
    },

    {
      title: "Friday",
      Isenable: false,
    },

    {
      title: "Saturday",
      Isenable: false,
    },

    {
      title: "Sunday",
      Isenable: false,
    },
  ]);
  // ✅ ADD: default Available All Days = YES -> UI show all days checked (Food category மட்டும்)
  useEffect(() => {
    const isFoodCategory = String(formData.category) === "2";

    if (isFoodCategory && availableAllDays) {
      setdateOfWeek((prev) => prev.map((d) => ({ ...d, Isenable: true })));
      setSelectedDays([
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ]);
    }
  }, [formData.category, availableAllDays]);

  // ✅ ADD: used in toggle (already referenced)
  const [selectedDays, setSelectedDays] = useState([]);

  const handleAvailableAllDaysToggle = () => {
    const next = !availableAllDays;
    setAvailableAllDays(next);

    if (next) {
      // ✅ ON => All days should be enabled
      setSelectedDays([
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ]);

      setdateOfWeek((prev) =>
        prev.map((d) => ({
          ...d,
          Isenable: true, // ✅ all true
        })),
      );

      setFormData((prev) => ({ ...prev, availableDays: "all" }));
    } else {
      // ✅ OFF => start manual selection (keep current selection OR clear)
      setFormData((prev) => ({ ...prev, availableDays: [] }));
    }
  };

  const handleDayToggle = (title) => {
    setdateOfWeek((prevDays) =>
      prevDays.map((day) =>
        day.title === title ? { ...day, Isenable: !day.Isenable } : day,
      ),
    );
  };

  // ✅ ADD ONLY: Vendor currency & symbol for display
  // 🔥 FIX: store/read currency PER VENDOR (not one global key)
  const vendorKey =
    user?.role === "vendor"
      ? "me"
      : vendorId
        ? `vendor_${vendorId}`
        : vendorProductResult?.data?.vendor_id
          ? `vendor_${vendorProductResult.data.vendor_id}`
          : "unknown";

  const [vendorCurrency, setVendorCurrency] = useState(
    sessionStorage.getItem(`vendor_currency_${vendorKey}`) || "GBP",
  );
  const [vendorCurrencySymbol, setVendorCurrencySymbol] = useState(
    sessionStorage.getItem(`vendor_currency_symbol_${vendorKey}`) || "£",
  );

  // ✅ ADD ONLY: helper to get symbol from currency code
  const currencyToSymbol = (code) => {
    if (!code) return code;
    try {
      const s = (0).toLocaleString("en", {
        style: "currency",
        currency: code,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
      return s.replace(/[0-9\s.,]/g, "") || code;
    } catch {
      return code;
    }
  };

  // ✅ ADD ONLY: HARD MAP fallback (if API/hook fails)
  const COUNTRY_TO_CURRENCY = {
    "Sri Lanka": "LKR",
    "sri lanka": "LKR",
    Srilanka: "LKR",
    srilanka: "LKR",
    India: "INR",
    india: "INR",
    "United Kingdom": "GBP",
    uk: "GBP",
    USA: "USD",
    "United States": "USD",
    Canada: "CAD",
    Australia: "AUD",
    Germany: "EUR",
    France: "EUR",
    Italy: "EUR",
    Spain: "EUR",
    Japan: "JPY",
    China: "CNY",
    UAE: "AED",
    Qatar: "QAR",
    "Saudi Arabia": "SAR",
    Singapore: "SGD",
    Malaysia: "MYR",
    Thailand: "THB",
    Indonesia: "IDR",
    Philippines: "PHP",
    Pakistan: "PKR",
    Bangladesh: "BDT",
    Nepal: "NPR",
  };

  // ✅ ADD ONLY: get vendor origin (vendor edits himself OR admin edits vendorId)
  const myVendorHook = useMyVendor(); // vendor self
  const vendorByIdHook = useVendorById(vendorId); // ✅ FIX: only vendorId (id is product id)

  const vendorOrigin =
    (user?.role === "vendor"
      ? myVendorHook?.data?.data?.origin ||
        myVendorHook?.data?.data?.country ||
        myVendorHook?.data?.data?.location
      : vendorId
        ? vendorByIdHook?.data?.data?.origin ||
          vendorByIdHook?.data?.data?.country ||
          vendorByIdHook?.data?.data?.location
        : vendorProductResult?.data?.vendor?.origin ||
          vendorProductResult?.data?.vendor?.country ||
          vendorProductResult?.data?.origin ||
          vendorProductResult?.data?.country) ||
    sessionStorage.getItem("country") ||
    "";

  // ✅ ADD ONLY: useMapLocation util to detect currency by country
  const { fetchCurrencyByCountryName } = useMapLocation();

  // ✅ ADD ONLY: when vendorKey changes, load that vendor's cached currency
  useEffect(() => {
    const cachedCur =
      sessionStorage.getItem(`vendor_currency_${vendorKey}`) || "GBP";
    const cachedSym =
      sessionStorage.getItem(`vendor_currency_symbol_${vendorKey}`) || "null";

    setVendorCurrency(cachedCur);
    setVendorCurrencySymbol(cachedSym);
  }, [vendorKey]);

  // ✅ ADD ONLY: direct currency_code from vendor API (if backend already gives)
  useEffect(() => {
    const directCur =
      (user?.role === "vendor"
        ? myVendorHook?.data?.data?.currency_code ||
          myVendorHook?.data?.data?.currency
        : vendorId
          ? vendorByIdHook?.data?.data?.currency_code ||
            vendorByIdHook?.data?.data?.currency
          : vendorProductResult?.data?.vendor?.currency_code ||
            vendorProductResult?.data?.currency_code ||
            vendorProductResult?.data?.currency) || null;

    if (directCur) {
      const finalCur = String(directCur).toUpperCase();
      const finalSym = currencyToSymbol(finalCur);

      setVendorCurrency(finalCur);
      setVendorCurrencySymbol(finalSym);

      sessionStorage.setItem(`vendor_currency_${vendorKey}`, finalCur);
      sessionStorage.setItem(`vendor_currency_symbol_${vendorKey}`, finalSym);
    }
  }, [
    user?.role,
    vendorId,
    vendorKey,
    myVendorHook?.data,
    vendorByIdHook?.data,
    vendorProductResult?.data,
  ]);

  useEffect(() => {
    let cancelled = false;

    const resolveVendorCurrency = async () => {
      if (!vendorOrigin) return;

      try {
        let cur = null;

        // ✅ If hook exists, try it
        if (fetchCurrencyByCountryName) {
          cur = await fetchCurrencyByCountryName(vendorOrigin);
        }

        // ✅ ADD ONLY fallback: if API didn't return, use map
        if (!cur) {
          const key = (vendorOrigin || "").trim();
          cur =
            COUNTRY_TO_CURRENCY[key] || COUNTRY_TO_CURRENCY[key.toLowerCase()];
        }

        if (cancelled) return;

        const finalCur = (cur || "GBP").toUpperCase();
        const finalSym = currencyToSymbol(finalCur);

        setVendorCurrency(finalCur);
        setVendorCurrencySymbol(finalSym);

        // ✅ store per vendor for next pages too
        sessionStorage.setItem(`vendor_currency_${vendorKey}`, finalCur);
        sessionStorage.setItem(`vendor_currency_symbol_${vendorKey}`, finalSym);
      } catch (e) {
        // fallback keep previous
      }
    };

    resolveVendorCurrency();
    return () => (cancelled = true);
  }, [vendorOrigin, vendorKey, fetchCurrencyByCountryName]);
  // ✅ ADD ONLY END

  // Fixed Save handler for vendor edit
  const handleVendorEditSave = async (e) => {
    e.preventDefault();
    setVendorSaveLoading(true);
    let respons = false;

    try {
      console.log("=== Starting Vendor Product Save ===");
      console.log("User role:", user?.role);
      console.log("Vendor ID from params:", vendorId);
      console.log("User vendor ID from user object:", user?.vendor?.vendor_id);
      console.log("User vendor ID from hook:", myVendorHook?.data?.data?.vendor_id);
      console.log("Form data product_id:", formData.product_id);
      console.log("Has variants:", HasVariants);
      console.log("Variable prices:", variablePrices);

      // ✅ Resolve vendor_id properly
      const resolvedVendorId =
        vendorId ||
        (user?.role === "vendor"
          ? user?.vendor?.vendor_id || myVendorHook?.data?.data?.vendor_id
          : null) ||
        vendorProductResult?.data?.vendor_id;

      if (!resolvedVendorId) {
        toast.error("Vendor ID not found. Please try again.");
        setVendorSaveLoading(false);
        return;
      }

      console.log("Resolved Vendor ID:", resolvedVendorId);

      // ✅ VALIDATION: Check minimum commission for variants
      if (HasVariants) {
        for (const v of variablePrices) {
          const commissionVal = Number(v.commissionPercent);
          if (minCommission > 0 && commissionVal < minCommission) {
            toast.error(
              `Commission for variant ${v.name} cannot be less than ${minCommission}%`,
            );
            setVendorSaveLoading(false);
            return;
          }
        }
      } else if (singleProduct || (!HasVariants && formData.price)) {
        // ✅ VALIDATION: Check minimum commission for single product
        const commissionVal = Number(formData.commissionPercent);
        if (minCommission > 0 && commissionVal < minCommission) {
          toast.error(`Commission cannot be less than ${minCommission}%`);
          setVendorSaveLoading(false);
          return;
        }
      }

      // Normalize availability data
      const isFoodCategory = String(formData.category) === "2";
      const ALL_DAYS_TRUE = [
        { title: "Monday", Isenable: true },
        { title: "Tuesday", Isenable: true },
        { title: "Wednesday", Isenable: true },
        { title: "Thursday", Isenable: true },
        { title: "Friday", Isenable: true },
        { title: "Saturday", Isenable: true },
        { title: "Sunday", Isenable: true },
      ];

      const daysPayload = !isFoodCategory
        ? []
        : availableAllDays
          ? ALL_DAYS_TRUE
          : daysOfWeek;

      const availableFromPayload =
        isFoodCategory && !alwaysAvailable
          ? toTimeWithSeconds(formData.availableFrom)
          : null;

      const availableToPayload =
        isFoodCategory && !alwaysAvailable
          ? toTimeWithSeconds(formData.availableTo)
          : null;

      const availableDaysJson = JSON.stringify(daysPayload);

      if (HasVariants) {
        // 🔹 Case 1: Process multiple product variants
        const results = [];

        for (const v of variablePrices) {
          // ✅ Check if variant has any meaningful data
          const priceValue =
            v.price !== undefined && v.price !== null && v.price !== ""
              ? Number(v.price)
              : null;
          const taxValue =
            v.taxValue !== undefined && v.taxValue !== null && v.taxValue !== ""
              ? Number(v.taxValue)
              : null;
          const commissionValue =
            v.commissionPercent !== undefined &&
            v.commissionPercent !== null &&
            v.commissionPercent !== ""
              ? Number(v.commissionPercent)
              : null;

          // ✅ Check if user entered ANY data for this variant
          const hasAnyData =
            priceValue !== null ||
            taxValue !== null ||
            commissionValue !== null;

          if (!hasAnyData) {
            console.log(
              `⏭️ Skipping variant ${v.sku} (${v.name}) - no data entered`,
            );
            continue; // Skip variants with no data at all
          }

          // ✅ For NEW variants, require at least price
          if (
            !v.vendor_product_id &&
            (priceValue === null || priceValue <= 0)
          ) {
            console.log(
              `⚠️ Skipping NEW variant ${v.sku} (${v.name}) - price required for new entries`,
            );
            continue;
          }

          // ✅ Build payload
          const payload = {
            vendor_id: resolvedVendorId,
            product_id: formData.product_id || formData.productName,
            sku_id: v.sku,
            price: priceValue !== null ? priceValue : 0,
            tax_value: taxValue !== null ? taxValue : 0,
            commission_percent: commissionValue !== null ? commissionValue : 0,
            currency_symbol: vendorCurrencySymbol || "£",
            available_from: availableFromPayload,
            available_to: availableToPayload,
            available_days: availableDaysJson,
          };

          console.log(`📦 Processing variant ${v.sku} (${v.name}):`, {
            hasVendorProductId: !!v.vendor_product_id,
            action: v.vendor_product_id ? "UPDATE" : "CREATE",
            payload,
          });

          try {
            if (v.vendor_product_id) {
              // ✅ UPDATE existing vendor product
              console.log(
                `🔄 Updating variant ${v.sku} with ID ${v.vendor_product_id}`,
              );
              const updateResult = await useProducts().updateVendorProduct(
                v.vendor_product_id,
                payload,
                "vendor",
              );
              console.log(`✅ Update result for ${v.sku}:`, updateResult);
              results.push({
                sku: v.sku,
                name: v.name,
                action: "update",
                success: updateResult?.success || false,
                vendor_product_id: v.vendor_product_id,
              });
            } else {
              // ✅ CREATE new vendor product
              console.log(`➕ Creating new variant ${v.sku} (${v.name})`);
              const createResult =
                await useProducts().addVendorProduct(payload);
              console.log(`✅ Create result for ${v.sku}:`, createResult);
              results.push({
                sku: v.sku,
                name: v.name,
                action: "create",
                success: createResult?.success || false,
                data: createResult?.data,
              });
            }
          } catch (error) {
            console.error(`❌ Failed to process variant ${v.sku}:`, error);
            results.push({
              sku: v.sku,
              name: v.name,
              action: v.vendor_product_id ? "update" : "create",
              success: false,
              error: error.message || error,
            });
          }
        }

        // ✅ Check if at least one operation succeeded
        const anySuccess = results.some((r) => r.success);
        const allFailed = results.every((r) => !r.success);

        console.log("📊 Variant processing results:", results);
        console.log(
          "✅ Successful operations:",
          results.filter((r) => r.success).length,
        );
        console.log(
          "❌ Failed operations:",
          results.filter((r) => !r.success).length,
        );

        respons = {
          success: anySuccess && !allFailed,
          results,
          allFailed,
        };
      } else if (singleProduct || (!HasVariants && formData.price)) {
        // 🔹 Case 2: Update single product (no variants)
        const payload = {
          price: Number(formData.price) || 0,
          tax_value: Number(formData.taxValue) || 0,
          commission_percent: Number(formData.commissionPercent) || 0,
          available_from: availableFromPayload,
          available_to: availableToPayload,
          available_days: availableDaysJson,
          currency_symbol: vendorCurrencySymbol || "£",
        };

        console.log("📦 Processing single product:", {
          hasVendorProductId: !!singleProduct?.vendor_product_id,
          payload,
        });

        if (singleProduct?.vendor_product_id) {
          // ✅ UPDATE existing
          console.log("🔄 Updating single product");
          respons = await useProducts().updateVendorProduct(
            singleProduct.vendor_product_id,
            payload,
            "vendor",
          );
        } else {
          // ✅ CREATE new
          console.log("➕ Creating new single product");
          respons = await useProducts().addVendorProduct({
            ...payload,
            vendor_id: resolvedVendorId,
            product_id: formData.product_id || formData.productName,
            sku_id: null, // Single product has no SKU
          });
        }
      } else {
        toast.error("No product data to save");
        setVendorSaveLoading(false);
        return;
      }

      // ✅ Handle response
      if (respons.success) {
        // Show detailed success message for variants
        if (HasVariants && respons.results) {
          const updated = respons.results.filter(
            (r) => r.action === "update" && r.success,
          ).length;
          const created = respons.results.filter(
            (r) => r.action === "create" && r.success,
          ).length;
          const failed = respons.results.filter((r) => !r.success).length;

          let message = "Product variants saved successfully! ";
          const parts = [];
          if (updated > 0) parts.push(`${updated} updated`);
          if (created > 0) parts.push(`${created} created`);
          if (failed > 0) parts.push(`${failed} failed`);

          toast.success(message + (parts.length > 0 ? parts.join(", ") : ""), {
            position: "top-right",
            autoClose: 4000,
          });

          // ✅ Log failed variants for debugging
          if (failed > 0) {
            const failedVariants = respons.results.filter((r) => !r.success);
            console.error("❌ Failed variants:", failedVariants);
            failedVariants.forEach((fv) => {
              console.error(
                `  - ${fv.name} (${fv.sku}): ${fv.error || "Unknown error"}`,
              );
            });
          }
        } else {
          toast.success("Product saved successfully!", {
            position: "top-right",
            autoClose: 3000,
          });
        }

        // ✅ Refetch to get updated data
        await refetchVendorProductResult();

        // ✅ Navigate back
        setTimeout(() => {
          if (user?.role === "admin" || user?.role === "employee") {
            navigate(`/product?vendor_id=${resolvedVendorId}`);
          } else {
            navigate("/product");
          }
        }, 1000);
      } else if (respons.allFailed) {
        toast.error(
          "All variants failed to save. Please check console for details.",
        );
      } else {
        toast.error("Product save failed! Please try again.");
      }
    } catch (error) {
      console.error("❌ Save error:", error);
      toast.error(
        `Failed to save product: ${error.message || "Unknown error"}`,
      );
    } finally {
      setVendorSaveLoading(false);
    }
  };

  //API get or post
  //Get the available products
  const {
    data: getVendorAvailableProducts,
    isLoading: getVendorAvailableProductsLoading,
    isError: getVendorAvailableProductsLoadingISError,
    error: getVendorAvailableProductsLoadingError,
    refetch: fetchAvailableProducts,
  } = useProducts().getAvailableProducts(
    vendorId ? { vendor_id: vendorId } : {},
  );

  // Always call hooks, but conditionally use their results
  const { data: productResult, isLoading: Loadingproduct } =
    getProductsByid(id);

  //Get the vendor product data
  useEffect(() => {
    if (!getVendorAvailableProductsLoading && getVendorAvailableProducts.data) {
      let productList;
      // Use the same mapping for all users since the endpoint now returns consistent data
      productList = getVendorAvailableProducts.data.map((item) => ({
        id: item.product_id,
        name: item.product_name,
        category_id: item.category_id,
      }));

      if (productList.length === 0) {
        setError("No new products available to add");
      } else {
        setProducts(productList);
      }
    } else {
      setError("No available products found");
    }

    if (
      !getVendorAvailableProductsLoading &&
      getVendorAvailableProductsLoadingISError
    ) {
      if (getVendorAvailableProductsLoadingISError?.response?.status === 403) {
        setError("You must be logged in as a vendor to add products");
      } else {
        setError("Failed to fetch available products. Please try again.");
      }
    }
  }, [
    getVendorAvailableProductsLoading,
    getVendorAvailableProductsLoadingISError,
  ]);

  // get Vendor Products skuid
  const getVendorProductsskuid = (sku_id) => {
    if (vendorProductResult?.data?.product_variables.length > 0) {
      let select_variable = vendorProductResult?.data?.product_variables?.find(
        (variant) => variant?.sku_id === sku_id,
      );
      return select_variable;
    }
    return undefined;
  };

  // Populate edit state for vendor edit mode
  // Fech product vendor info
  useEffect(() => {
    if (!vendorProductLoading) {
      if (
        (user?.role === "admin" || user?.role === "employee") &&
        id &&
        vendorProductResult?.data
      ) {
        const hasVariantsNow =
          vendorProductResult.data.product_variables &&
          vendorProductResult.data.product_variables.length > 0;
        const singleProductNow = vendorProductResult?.data?.vendor_products[0];

        sethasVariants(hasVariantsNow);
        setsingleProduct(singleProductNow);

        if (hasVariantsNow) {
          if (vendorProductResult?.data?.vendor_products?.length > 0) {
            setVariablePrices(
              vendorProductResult?.data?.vendor_products.map((v) => ({
                vendor_product_id: v.vendor_product_id ?? null,
                sku: v.sku_id,
                name: getVendorProductsskuid(v.sku_id)?.variable_name ?? "",
                price: v.price,
                taxValue: v.tax_value,
                commissionPercent: v.commission_percent ?? 0,
                available_from: v.available_from ?? null,
                available_to: v.available_to ?? null,
              })) || [],
            );

            const toHHmm = (t) => (t ? String(t).slice(0, 5) : "");

            // ✅ pick any saved time (first non-null) from variants
            const vp = vendorProductResult?.data?.vendor_products || [];
            const anyFrom =
              vp.find((x) => x?.available_from)?.available_from || null;
            const anyTo = vp.find((x) => x?.available_to)?.available_to || null;

            setFormData((prev) => ({
              ...prev,
              availableFrom: toHHmm(anyFrom),
              availableTo: toHHmm(anyTo),
            }));

            // ✅ DB-la time iruntha => Always Available Time must be NO
            setAlwaysAvailable(!(anyFrom || anyTo));

            if (vendorProductResult?.data?.vendor_products[0].available_days) {
              let available_days = JSON.parse(
                vendorProductResult?.data?.vendor_products[0].available_days ||
                  [],
              );

              if (available_days.length > 0) {
                setdateOfWeek(available_days);
                setAvailableAllDays(false);
              } else {
                // empty array => all days
                setAvailableAllDays(true);
                setdateOfWeek((prev) =>
                  prev.map((d) => ({ ...d, Isenable: true })),
                );
                setSelectedDays([
                  "Monday",
                  "Tuesday",
                  "Wednesday",
                  "Thursday",
                  "Friday",
                  "Saturday",
                  "Sunday",
                ]);
              }
            }
          }
        } else if (singleProductNow?.sku_id === null) {
          setFormData((prev) => ({
            ...prev,
            price:
              singleProductNow.price !== null &&
              singleProductNow.price !== undefined
                ? singleProductNow.price
                : 0.0,
            taxValue:
              singleProductNow.tax_value !== null &&
              singleProductNow.tax_value !== undefined
                ? singleProductNow.tax_value
                : 0.0,
            commissionPercent:
              singleProductNow.commission_percent !== null &&
              singleProductNow.commission_percent !== undefined
                ? singleProductNow.commission_percent
                : 0,
          }));

          const toHHmm = (t) => (t ? String(t).slice(0, 5) : "");
          const af = singleProductNow?.available_from || null;
          const at = singleProductNow?.available_to || null;

          setFormData((prev) => ({
            ...prev,
            availableFrom: toHHmm(af),
            availableTo: toHHmm(at),
          }));

          setAlwaysAvailable(!(af || at));

          if (singleProductNow.available_days) {
            const safeParseDays = (v) => {
              try {
                if (!v) return [];
                if (Array.isArray(v)) return v;
                if (typeof v === "string") return JSON.parse(v);
                return [];
              } catch {
                return [];
              }
            };

            const available_days = safeParseDays(
              singleProductNow?.available_days,
            );

            if (available_days.length > 0) {
              setdateOfWeek(available_days);
              setAvailableAllDays(false); // ✅ show selected day checkboxes
            } else {
              setAvailableAllDays(true);
              setdateOfWeek((prev) =>
                prev.map((d) => ({ ...d, Isenable: true })),
              );
              setSelectedDays([
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
                "Sunday",
              ]);
            }
          }
        }
        setNewVariantInputs({});
      }
    }
  }, [vendorProductLoading, id, user?.role]);

  //   useEffect(() => {
  //   if (!vendorProductLoading && vendorProductResult?.data) {

  //     const hasVariantsNow =
  //       vendorProductResult.data.product_variables?.length > 0;

  //     sethasVariants(hasVariantsNow);

  //     if (!hasVariantsNow) return;

  //     // 🔹 STEP 1: vendor_products → map by sku_id
  //     const vendorProductMap = {};
  //     (vendorProductResult.data.vendor_products || []).forEach(vp => {
  //       vendorProductMap[vp.sku_id] = vp;
  //     });

  //     // 🔹 STEP 2: ALWAYS map from product_variables
  //     const variablePricesData =
  //       vendorProductResult.data.product_variables.map(variant => {
  //         const existing = vendorProductMap[variant.sku_id];

  //         return {
  //           vendor_product_id: existing?.vendor_product_id ?? null,
  //           sku: variant.sku_id,
  //           name: variant.variable_name,
  //           price: existing?.price ?? "",
  //           taxValue: existing?.tax_value ?? "",
  //           commissionPercent: existing?.commission_percent ?? 0,
  //         };
  //       });

  //     setVariablePrices(variablePricesData);
  //   }
  // }, [vendorProductLoading, vendorProductResult?.data]);

  // ✅ REPLACE your existing useEffect that loads vendor product data with this:

  useEffect(() => {
    if (!vendorProductLoading && vendorProductResult?.data) {
      console.log("📦 Loading vendor product data:", vendorProductResult.data);

      const hasVariantsNow =
        vendorProductResult.data.product_variables?.length > 0;

      sethasVariants(hasVariantsNow);

      if (hasVariantsNow) {
        console.log("🔄 Product has variants, loading all variants...");

        // ✅ STEP 1: Create a map of existing vendor_products by sku_id
        const vendorProductMap = {};
        (vendorProductResult.data.vendor_products || []).forEach((vp) => {
          if (vp.sku_id) {
            vendorProductMap[vp.sku_id] = vp;
          }
        });

        console.log("📊 Existing vendor products map:", vendorProductMap);

        // ✅ STEP 2: ALWAYS map from ALL product_variables (not just vendor_products)
        // This ensures ALL variants show up, whether they have prices or not
        const variablePricesData =
          vendorProductResult.data.product_variables.map((variant) => {
            const existingVendorProduct = vendorProductMap[variant.sku_id];

            console.log(
              `  - Variant ${variant.sku_id} (${variant.variable_name}):`,
              {
                hasExistingData: !!existingVendorProduct,
                vendor_product_id:
                  existingVendorProduct?.vendor_product_id || "NEW",
                price: existingVendorProduct?.price || "empty",
              },
            );

            return {
              vendor_product_id:
                existingVendorProduct?.vendor_product_id ?? null,
              sku: variant.sku_id,
              name: variant.variable_name,
              // ✅ Use existing values if available, otherwise empty string for user input
              price: existingVendorProduct?.price ?? "",
              taxValue: existingVendorProduct?.tax_value ?? "",
              commissionPercent:
                existingVendorProduct?.commission_percent ??
                (minCommission || ""),
              available_from: existingVendorProduct?.available_from ?? null,
              available_to: existingVendorProduct?.available_to ?? null,
            };
          });

        console.log("✅ Final variablePrices array:", variablePricesData);
        setVariablePrices(variablePricesData);

        // ✅ Set common availability times from first variant that has them
        const vp = vendorProductResult.data.vendor_products || [];
        const toHHmm = (t) => (t ? String(t).slice(0, 5) : "");
        const anyFrom =
          vp.find((x) => x?.available_from)?.available_from || null;
        const anyTo = vp.find((x) => x?.available_to)?.available_to || null;

        setFormData((prev) => ({
          ...prev,
          availableFrom: toHHmm(anyFrom),
          availableTo: toHHmm(anyTo),
          product_id: vendorProductResult.data.product_id,
          productName: vendorProductResult.data.product_name || "",
          category: vendorProductResult.data.category_id?.toString() || "",
          subcategory:
            vendorProductResult.data.subcategory_id?.toString() || "",
          description: vendorProductResult.data.description || "",
          status: vendorProductResult.data.status || "active",
          ageValidation: vendorProductResult.data.age_validation_flag || false,
          product_image: vendorProductResult.data.product_image || "",
        }));

        setAlwaysAvailable(!(anyFrom || anyTo));

        // ✅ Handle available days
        if (vp[0]?.available_days) {
          try {
            const available_days = JSON.parse(vp[0].available_days);
            if (available_days.length > 0) {
              setdateOfWeek(available_days);
              setAvailableAllDays(false);
            } else {
              // Empty array means all days
              setAvailableAllDays(true);
              setdateOfWeek((prev) =>
                prev.map((d) => ({ ...d, Isenable: true })),
              );
              setSelectedDays([
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
                "Sunday",
              ]);
            }
          } catch (e) {
            console.error("Error parsing available_days:", e);
          }
        }
      } else {
        // ✅ Single product (no variants)
        console.log("📦 Product has no variants, loading single product...");

        const singleProductNow = vendorProductResult.data.vendor_products?.[0];
        setsingleProduct(singleProductNow);

        if (singleProductNow) {
          const toHHmm = (t) => (t ? String(t).slice(0, 5) : "");
          const af = singleProductNow?.available_from || null;
          const at = singleProductNow?.available_to || null;

          setFormData((prev) => ({
            ...prev,
            product_id: vendorProductResult.data.product_id,
            productName: vendorProductResult.data.product_name || "",
            category: vendorProductResult.data.category_id?.toString() || "",
            subcategory:
              vendorProductResult.data.subcategory_id?.toString() || "",
            description: vendorProductResult.data.description || "",
            status: vendorProductResult.data.status || "active",
            ageValidation:
              vendorProductResult.data.age_validation_flag || false,
            product_image: vendorProductResult.data.product_image || "",
            price: singleProductNow.price ?? "",
            taxValue: singleProductNow.tax_value ?? "",
            commissionPercent: singleProductNow.commission_percent ?? "",
            availableFrom: toHHmm(af),
            availableTo: toHHmm(at),
          }));

          setAlwaysAvailable(!(af || at));

          // Handle available days for single product
          if (singleProductNow.available_days) {
            try {
              const available_days = JSON.parse(
                singleProductNow.available_days,
              );
              if (available_days.length > 0) {
                setdateOfWeek(available_days);
                setAvailableAllDays(false);
              } else {
                setAvailableAllDays(true);
                setdateOfWeek((prev) =>
                  prev.map((d) => ({ ...d, Isenable: true })),
                );
                setSelectedDays([
                  "Monday",
                  "Tuesday",
                  "Wednesday",
                  "Thursday",
                  "Friday",
                  "Saturday",
                  "Sunday",
                ]);
              }
            } catch (e) {
              console.error("Error parsing available_days:", e);
            }
          }
        }
      }

      // Clear any new variant inputs
      setNewVariantInputs({});
    }
  }, [vendorProductLoading, vendorProductResult?.data, minCommission]);

  useEffect(() => {
    if (formData.productName && !id) {
      // Find the selected product from products list
      const selectedProduct = products.find(
        (p) => p.id == formData.productName,
      );
      if (selectedProduct) {
        setLoading(true);
        // Fetch product details (including variables)
        apiClient
          .get(`/quik/productvariable/${formData.productName}`)
          .then((res) => {
            const variables = res.data?.data || [];
            if (variables.length > 0) {
              sethasVariants(true);
              setVariablePrices(
                variables.map((v) => ({
                  sku: v.sku_id,
                  name: v.variable_name,
                  price: "",
                  taxValue: "",
                  commissionPercent:
                    v.commission_percent || minCommission || "",
                })),
              );
            } else {
              setVariablePrices([]);
            }

            setLoading(false);
          });
      }
    } else if (!id) {
      setLoading(false);
      setVariablePrices([]);
    }
  }, [formData.productName, minCommission]);

  useEffect(() => {
    setLoading(false);
    setVendorSaveLoading(false);
    setError("");
  }, []);
  //Handel input value chage

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    console.log("Input change:", { name, value, type, checked });
    // If vendor or admin/employee with vendorId selects a product, set category as well
    //Combo box select prodct name
    if (!id && name === "productName" && isVendorOrSuperUsers()) {
      // Find the selected product from products list
      const selectedProduct = products.find((p) => p.id == value);

      setFormData((prev) => {
        const newData = {
          ...prev,
          [name]: value,
          // Set category if found

          category: selectedProduct ? String(selectedProduct.category_id) : "",
          // Optionally reset subcategory if product changes
          subcategory: "",
          product_id: selectedProduct?.id ? selectedProduct.id : 0,
          // Don't reset price and taxValue - let user keep their values
        };
        console.log("Updated formData in handleInputChange:", newData);
        return newData;
      });
      return;
    }
    // If category changes, reset subcategory
    if (name === "category") {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
        subcategory: "", // Reset subcategory when category changes
      }));
    } else {
      setFormData((prev) => {
        const newData = {
          ...prev,
          [name]: type === "checkbox" ? checked : value,
        };
        console.log("Updated formData:", newData);
        return newData;
      });
    }
  };
  // Handler for variable price/tax input

  const handleVariablePriceChange = (index, field, value) => {
    setVariablePrices((prev) =>
      prev.map((v, i) => (i === index ? { ...v, [field]: value } : v)),
    );
  };

  // For all vendor or vendor id incude admin or employee
  if (isVendorOrSuperUsers()) {
    // Show vendor edit UI when source=vendor

    if (getVendorAvailableProductsLoading)
      return <div>Loading vendor data...</div>;
    if (!getVendorAvailableProducts?.data)
      return <div>No vendor product data found </div>;

    return (
      <div className="container py-4">
        <ToastContainer />
        <h2 className="mb-4 text-primary">
          {user?.role === "vendor"
            ? "Edit Vendor Product"
            : "Edit Product (Admin/Employee)"}
        </h2>
        {/* Vendor submit form */}

        <form onSubmit={handleVendorEditSave}>
          {/* product name */}

          <div className="mb-4 row align-items-center">
            <label className="form-label-title col-sm-3 mb-0">
              Product Name
            </label>
            <div className="col-sm-9">
              {isVendorOrSuperUsers() && !id ? (
                getVendorAvailableProductsLoading ? (
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                ) : error ? (
                  <div className="alert alert-danger">{error}</div>
                ) : (
                  <select
                    className="form-select"
                    name="productName"
                    value={formData.productName}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="" disabled>
                      Select a product
                    </option>
                    {products &&
                      products.map((product) => (
                        <option key={product.id} value={product.id}>
                          {product.name}
                        </option>
                      ))}
                  </select>
                )
              ) : (
                <input
                  type="text"
                  className="form-control"
                  name="productName"
                  value={formData.productName}
                  onChange={handleInputChange}
                  placeholder="Enter product name"
                  readOnly={!!id}
                  required
                />
              )}
            </div>
          </div>

          {loading && <div>Loading ...</div>}

          {!loading && (
            <>
              {/* Price of product for vendor or vendor id based admin or employee*/}

              {isVendorOrSuperUsers() && variablePrices.length === 0 && (
                <>
                  <div className="mb-4 row align-items-center">
                    <label className="form-label-title col-sm-3 mb-0">
                      Price
                    </label>
                    <div className="col-sm-9">
                      <div className="input-group">
                        <span className="input-group-text">
                          {vendorCurrencySymbol}
                        </span>
                        <input
                          type="number"
                          className="form-control"
                          name="price"
                          value={formData.price ?? 0}
                          onChange={handleInputChange}
                          placeholder={`Enter price (${vendorCurrency})`}
                          step="0.01"
                          min="0"
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="mb-4 row align-items-center">
                    <label className="form-label-title col-sm-3 mb-0">
                      Tax %
                    </label>
                    <div className="col-sm-9">
                      <div className="input-group">
                        <input
                          type="number"
                          className="form-control"
                          name="taxValue"
                          value={formData.taxValue ?? 0}
                          onChange={(e) => {
                            const value = e.target.value;
                            // Allow only positive integers (no decimals or negative)
                            if (/^\d*$/.test(value)) {
                              handleInputChange(e);
                            }
                          }}
                          placeholder="Enter tax percentage"
                          min="0"
                          max="100"
                          inputMode="numeric"
                          required
                        />
                        <span className="input-group-text">%</span>
                      </div>

                      <small className="text-muted">
                        Enter a whole number between 0 and 100 (e.g. 15 for 15%)
                      </small>
                    </div>
                  </div>

                  {/* Commission Percentage */}

                  <div className="mb-4 row align-items-center">
                    <label className="form-label-title col-sm-3 mb-0">
                      Commission %
                    </label>
                    <div className="col-sm-9">
                      <div className="input-group">
                        <input
                          type="number"
                          className="form-control"
                          name="commissionPercent"
                          value={formData.commissionPercent}
                          onChange={(e) => {
                            const value = e.target.value;
                            // Allow only positive integers (no decimals or negative)

                            if (/^\d*$/.test(value)) {
                              handleInputChange(e);
                            }
                          }}
                          placeholder="Enter commission"
                          min={minCommission || 0}
                          max="100"
                          inputMode="numeric"
                          required
                        />
                        <span className="input-group-text">%</span>
                      </div>
                      <small className="text-muted">
                        Enter a whole number between 0 and 100 (e.g. 10 for 10%)
                      </small>
                    </div>
                  </div>
                </>
              )}

              {isVendorOrSuperUsers() && String(formData.category) === "2" && (
                <div className="mb-4 row align-items-center">
                  <label className="form-label-title col-sm-3 mb-0">
                    Available All Days
                  </label>
                  <div className="col-sm-9">
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={availableAllDays}
                        onChange={handleAvailableAllDaysToggle}
                      />
                      <label className="form-check-label">
                        {availableAllDays ? "Yes" : "No"}
                      </label>
                    </div>
                  </div>

                  {!availableAllDays && (
                    <div className="col-sm-9 offset-sm-3 mt-2">
                      {daysOfWeek.map((day) => (
                        <div className="form-check form-check-inline" key={day}>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={day.Isenable}
                            onChange={(e) => handleDayToggle(day.title)}
                          />
                          <label className="form-check-label">
                            {day?.title ?? false}
                          </label>
                        </div>
                      ))}
                    </div>
                  )}

                  {availableAllDays && (
                    <div className="col-sm-9 offset-sm-3 mt-2 text-success">
                      Available for all days
                    </div>
                  )}
                </div>
              )}
              {/* Set Availability Time */}

              {isVendorOrSuperUsers() && String(formData.category) === "2" && (
                <>
                  <div className="mb-4 row align-items-center">
                    <label className="form-label-title col-sm-3 mb-0">
                      Always Available Time
                    </label>
                    <div className="col-sm-9">
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={alwaysAvailable}
                          onChange={() => {
                            setAlwaysAvailable((prev) => {
                              const next = !prev;

                              // ✅ If switched to YES, clear time fields
                              if (next) {
                                setFormData((fd) => ({
                                  ...fd,
                                  availableFrom: "",
                                  availableTo: "",
                                }));
                              }

                              return next;
                            });
                          }}
                        />
                        <label className="form-check-label">
                          {alwaysAvailable ? "Yes" : "No"}
                        </label>
                      </div>
                    </div>
                  </div>

                  {!alwaysAvailable && (
                    <>
                      <div className="mb-4 row align-items-center">
                        <label className="form-label-title col-sm-3 mb-0">
                          Available From
                        </label>
                        <div className="col-sm-9">
                          <input
                            type="time"
                            className="form-control"
                            name="availableFrom"
                            value={formData.availableFrom}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>

                      <div className="mb-4 row align-items-center">
                        <label className="form-label-title col-sm-3 mb-0">
                          Available To
                        </label>
                        <div className="col-sm-9">
                          <input
                            type="time"
                            className="form-control"
                            name="availableTo"
                            value={formData.availableTo}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>
                    </>
                  )}
                </>
              )}

              {isVendorOrSuperUsers() && variablePrices.length > 0 && (
                <div className="mb-4 row align-items-center">
                  <label className="form-label-title col-sm-3 mb-0">
                    Product Variants
                  </label>
                  <div className="col-sm-10">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Variant</th>
                          <th>SKU</th>
                          <th>Price</th>
                          <th>Tax Value (%)</th>
                          <th>Commission (%)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {variablePrices.map((v, idx) => (
                          <tr key={v.sku}>
                            <td>{v.name}</td>
                            <td>{v.sku}</td>

                            <td>
                              <div className="input-group">
                                <span className="input-group-text">
                                  {vendorCurrencySymbol}
                                </span>
                                <input
                                  type="number"
                                  className="form-control"
                                  pattern="[0-9]+(\\.[0-9][0-9]?)?"
                                  value={v.price === "" ? "" : Number(v.price)}
                                  placeholder={`Enter price (${vendorCurrency})`}
                                  onChange={(e) =>
                                    handleVariablePriceChange(
                                      idx,
                                      "price",
                                      e.target.value,
                                    )
                                  }
                                />
                              </div>
                            </td>

                            <td>
                              <div className="input-group">
                                <input
                                  type="number"
                                  className="form-control"
                                  value={
                                    v.taxValue === "" || v.taxValue === null || v.taxValue === undefined
                                      ? ""
                                      : v.taxValue
                                  }

                                  placeholder="Enter tax %"
                                  min="0"
                                  max="100"
                                  inputMode="numeric"
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    // Allow only whole numbers 0-100
                                    if (/^\d*$/.test(value)) {
                                      handleVariablePriceChange(
                                        idx,
                                        "taxValue",
                                        value,
                                      );
                                    }
                                  }}
                                />
                                <span className="input-group-text">%</span>
                              </div>
                            </td>

                            <td>
                              <div className="input-group">
                                <input
                                  type="number"
                                  className="form-control"
                                  value={
                                      v.commissionPercent === "" ||
                                      v.commissionPercent === null ||
                                      v.commissionPercent === undefined
                                        ? ""
                                        : v.commissionPercent
                                    }

                                  placeholder="Enter commission"
                                  min={minCommission || 0}
                                  max="100"
                                  inputMode="numeric"
                                  onChange={(e) =>
                                    handleVariablePriceChange(
                                      idx,
                                      "commissionPercent",
                                      e.target.value,
                                    )
                                  }
                                />
                                <span className="input-group-text">%</span>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              <div className="row">
                <div className="col-sm-9 offset-sm-3">
                  <button
                    type="submit"
                    className="btn btn-primary px-4"
                    disabled={vendorSaveLoading}
                  >
                    {vendorSaveLoading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Saving...
                      </>
                    ) : (
                      "Save Changes"
                    )}
                  </button>
                </div>
              </div>
            </>
          )}
        </form>
      </div>
    );
    /* Vendor submit form end*/
  } else {
    // Fallback for backward compatibility - try to determine UI based on available data

    if (vendorProductResult?.data) {
      // If vendor data exists, show vendor UI

      if (vendorProductLoading) return <div>Loading vendor data...</div>;
      // Redirect to vendor UI logic

      return (
        <div className="container py-4">
          <ToastContainer />
          <div className="alert alert-info">
            Please use the correct edit link. Redirecting to vendor edit...
          </div>
        </div>
      );
    } else if (productResult?.data) {
      // If regular product data exists, show main form

      if (Loadingproduct) return <div>Loading product data...</div>;
      // Continue to main form UI below
    }
  }

  return (
    <div className="page-wrapper">
      <ToastContainer />
      <div className="content-wrapper">
        <div className="page-content">
          <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
            <div className="breadcrumb-title pe-3">Products</div>
            <div className="ps-3">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb mb-0 p-0">
                  <li className="breadcrumb-item">
                    <a href="javascript:;">
                      <i className="bx bx-home-alt"></i>
                    </a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    {id
                      ? "Edit Product"
                      : vendorId
                        ? `Add Product for Vendor ${vendorId}`
                        : "Add Product"}
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          {/* Show loading for regular product data */}

          {source === "list" && id && Loadingproduct && (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ minHeight: "200px" }}
            >
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading product data...</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
